import { render, staticRenderFns } from "./date-field.vue?vue&type=template&id=6f3f60fa&scoped=true&"
import script from "./date-field.vue?vue&type=script&lang=js&"
export * from "./date-field.vue?vue&type=script&lang=js&"
import style0 from "./date-field.vue?vue&type=style&index=0&id=6f3f60fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3f60fa",
  null
  
)

export default component.exports